import { useState, useEffect } from 'react';
import { selectUsers } from '../store/usersSlice';
import { useSelector } from 'react-redux';
import { fetchUserListRealTime, addNewList, deleteList, isAtListsLimit } from '../../firebase';
import styles from './Home.module.css';
import { Link } from 'react-router-dom';

const Home = () => {
  const user = useSelector(selectUsers);
  const [movieList, setMovieList] = useState({});
  const [listName, setListName] = useState('');
  const [showInput, setShowInput] = useState(false);

  useEffect(() => {
    if (!user || !user.currentUser?.listsId) {
      return;
    }

    const unsubscribe = fetchUserListRealTime(user.currentUser.listsId, setMovieList);

    return () => {
      if (unsubscribe) unsubscribe();
    }

  }, [user.currentUser?.listsId, user]);

  const handleCreateList = async (newListName) => {
    if (!newListName.trim()) return;
    const atLimit = await isAtListsLimit(user?.currentUser?.listsId);
    if (atLimit) {
      alert("You have reached the maximum amount of lists!");
      return;
    } else {
      addNewList(newListName)
      .then(() => {
        setListName('');
        setShowInput(false);
      })
    }
  }

  const handleDeleteList = (listsId, listId) => {
    deleteList(listsId, listId);
  }

  const listInfo = Object.values(movieList);

  return (
    <div className="Movie-List">
      <h1>Hello, {user?.currentUser?.name}!</h1>
      <div className={styles.list_grid}>
        {Object.entries(listInfo).map(([movieId, movie]) => (
          <div key={movieId} className={styles.listItem}>
            <Link to={`/list/${movie.sharedLink.slice(0,20)}`} className={styles.link}>
              {movie.listName}
            </Link>
            <button
              className={styles.deleteButton}
              onClick={() =>
                handleDeleteList(user?.currentUser?.listsId, movie.sharedLink.slice(0,20))}
              aria-label="Delete list"
            >
              <p style={{ marginBottom: 17 }}>x</p>
            </button>
          </div>
        ))}
        
        {!showInput ? (
          <div 
            className={styles.newListButton}
            onClick={() => setShowInput(true)}
            role="button"
            tabIndex={0}
          >
            <span className={styles.plusSign}>+</span>
          </div>
        ) : (
          <div className={styles.inputContainer}>
            <input 
              className={styles.input}
              name='listName' 
              value={listName}
              onChange={(e) => setListName(e.target.value)}
              placeholder="Enter list name"
              autoFocus
            />
            <div className={styles.buttonContainer}>
              <button 
                className={styles.createButton} 
                onClick={() => handleCreateList(listName)}
              >
                Create
              </button>
              <button 
                className={styles.createButton} 
                onClick={() => {
                  setShowInput(false);
                  setListName('');
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Home;
